import { Component, OnInit, ViewChild } from "@angular/core";
import { MedicalAppointmentValidation } from "../../../model/medical-appointment-validation";
import { MedicalOrderEditControlComponent } from "../../controls/medical-order/medical-order-edit/medical-order-edit-control.component";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { BillingMedicalOrder } from "../../../model/billing/billing-order-control";
import { validateMedicalOrderEdit } from "../../../validators/medical-order-edit.validator";
import { BillingOrdenControlWizardService } from "src/app/services/billing/billing-orden-control-wizard.service";
import { WizardStep } from "../../../wizard/wizard.component";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: "app-billing-orden-control-medical-order",
  templateUrl: "./billing-orden-control-medical-order.component.html",
  styleUrls: ["./billing-orden-control-medical-order.component.css"],
})
export class BillingOrdenControlMedicalOrderComponent
  implements OnInit, WizardStep
{
  isInit: boolean;
  loading: boolean;
  loadingInit: boolean;
  formGroup: FormGroup;
  @ViewChild("medicalOrderEdit", { static: false })
  medicalOrderEdit: MedicalOrderEditControlComponent;
  medicalAppointmentValidation: MedicalAppointmentValidation;

  constructor(
    private billingOrdenControlWizardService: BillingOrdenControlWizardService,
    private notificationToastService: NotificationToastService,
    private authService: AuthService,
    private formBuilder: FormBuilder
  ) {
    this.formGroup = this.formBuilder.group({
      MedicalOrderEdit: [null, [Validators.required, validateMedicalOrderEdit]],
    });

    this.formGroup.valueChanges.subscribe(() => {
      this.billingOrdenControlWizardService.setBillingMedicalOrder(
        <BillingMedicalOrder>this.formGroup.getRawValue()
      );
    });
  }

  get valid(): boolean {
    const isValid =
    !this.medicalOrderEdit.invalid &&
    (!this.medicalOrderEdit.validateOnLineRequired ||
      this.medicalAppointmentValidation ||
      this.authService.canNoValidateOnLine()) &&
    !this.formGroup.invalid;

  return isValid;
  }


  get validateOnLineRequired(): boolean {
    return (
      this.medicalOrderEdit.validateOnLineRequired &&
      !this.medicalAppointmentValidation
    );
  }

  get completed(): boolean {
    return !this.formGroup.invalid;
  }

  save(): void {}

  async executeOnLineOperation(isCancel: boolean) {
    try {
      this.medicalOrderEdit.validating = true;

      this.medicalAppointmentValidation =
        await this.billingOrdenControlWizardService
          .executeOnLineOperation(isCancel);

      if ( this.medicalAppointmentValidation.NoValidate ||
           this.medicalAppointmentValidation.PartialValidate ) {
        this.notificationToastService.error(
          this.medicalAppointmentValidation.DisplayMessage,
          "Validación on line"
        );
      } else {
        this.notificationToastService.success(
          this.medicalAppointmentValidation.DisplayMessage,
          "Validación on line"
        );
      }
    } catch (err) {
      this.medicalAppointmentValidation = new MedicalAppointmentValidation();
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Control órden", true
      );
    } finally {
      const medicalOrder =
        await this.billingOrdenControlWizardService.getBillingMedicalOrder();
      this.medicalOrderEdit.setValidationInfo(medicalOrder.MedicalOrderEdit);

      this.formGroup.patchValue({
        MedicalOrderEdit: medicalOrder.MedicalOrderEdit,
      });

      this.loading = false;
    }
  }

  async activate() {
    try {
      if (this.isInit) {
        this.loadingInit = true;
        await this.loadMedicalOrder();
        setTimeout(() => this.medicalOrderEdit.setFocus(), 0);
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Control órden"
      );
    } finally {
      this.loadingInit = false;
    }
  }

  private async loadMedicalOrder() {
    const billingMedicalOrder =
      await this.billingOrdenControlWizardService.getBillingMedicalOrder();
    billingMedicalOrder.MedicalOrderEdit.MedicalOrder.PlanId =
      billingMedicalOrder.MedicalOrderEdit.MedicalOrderEditInfo.PlanId;
    billingMedicalOrder.MedicalOrderEdit.MedicalOrder.IncompleteMedicalOrderAmount =
      billingMedicalOrder.MedicalOrderEdit.MedicalOrderEditInfo.IncompleteMedicalOrderAmount;
    billingMedicalOrder.MedicalOrderEdit.MedicalOrder.MedicalOrderStateId =
      billingMedicalOrder.MedicalOrderEdit.MedicalOrderEditInfo.MedicalOrderState.Id;
    billingMedicalOrder.MedicalOrderEdit.MedicalOrder.PatientId = (
      await this.billingOrdenControlWizardService.getPatient()
    ).Id;

    this.medicalOrderEdit.setValidationInfo(billingMedicalOrder.MedicalOrderEdit);

    this.formGroup.patchValue({
      MedicalOrderEdit: billingMedicalOrder.MedicalOrderEdit,
    });
  }

  async ngOnInit() {
    try {
      await this.loadMedicalOrder();
      setTimeout(() => this.medicalOrderEdit.setFocus(), 0);
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Control órden"
      );
    } finally {
      this.isInit = true;
    }
  }
}
